import { render, staticRenderFns } from "./ExcessAndSumInsuredFormFields.vue?vue&type=template&id=679968d2&"
import script from "./ExcessAndSumInsuredFormFields.vue?vue&type=script&lang=js&"
export * from "./ExcessAndSumInsuredFormFields.vue?vue&type=script&lang=js&"
import style0 from "./ExcessAndSumInsuredFormFields.vue?vue&type=style&index=0&id=679968d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports